import { entry as stringControlRendererEntry } from './stringControlRenderer';
import { entry as enumControlRendererEntry } from './enumControlRenderer';
import { entry as booleanControlRendererEntry } from './booleanControlRenderer';
import { entry as NumberControlRenderer } from './numberControlRenderer';
import { entry as OneOfEnumControlRenderer } from './isOneOfEnumControlRenderer';
import { entry as DateControlRenderer } from './dateControlRenderer';
import { entry as CustomEnumRenderer } from './customEnumRolesRenderer';
import { entry as CustomDestinationIpRenderer } from './destinationIpControlRenderer';

import { entry as stringControlRendererEntryV2 } from './v2/stringControlRenderer';
import { entry as enumControlRendererEntryV2 } from './v2/enumControlRenderer';
import { entry as booleanControlRendererEntryV2 } from './v2/booleanControlRenderer';
import { entry as NumberControlRendererV2 } from './v2/numberControlRenderer';
import { entry as OneOfEnumControlRendererV2 } from './v2/isOneOfEnumControlRenderer';
import { entry as DateControlRendererV2 } from './v2/dateControlRenderer';
import { entry as CustomEnumRendererV2 } from './v2/customEnumRolesRenderer';
import { entry as CustomDestinationIpRendererV2 } from './v2/destinationIpControlRenderer';

export const controlRenderers = [
  stringControlRendererEntry,
  enumControlRendererEntry,
  booleanControlRendererEntry,
  NumberControlRenderer,
  OneOfEnumControlRenderer,
  DateControlRenderer,
  CustomEnumRenderer,
  CustomDestinationIpRenderer,
  stringControlRendererEntryV2,
  enumControlRendererEntryV2,
  booleanControlRendererEntryV2,
  NumberControlRendererV2,
  OneOfEnumControlRendererV2,
  DateControlRendererV2,
  CustomEnumRendererV2,
  CustomDestinationIpRendererV2,
];
